var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.605,31.683c-0.813-0.276-1.708-0.004-2.229,0.676l-8.653,11.271V33.576c0-0.857-0.546-1.618-1.356-1.894 c-0.813-0.276-1.708-0.004-2.229,0.676l-9.401,12.245l-3.188-20.301c-0.152-0.973-0.991-1.69-1.976-1.69h-7.624 c-0.985,0-1.823,0.717-1.976,1.69l-3.911,24.905c-0.008,0.052-0.004,0.102-0.009,0.154c-0.004,0.053-0.016,0.104-0.016,0.158 v21.869c0,1.104,0.896,2,2,2h39.924c1.104,0,2-0.896,2-2V33.576C69.962,32.719,69.416,31.958,68.605,31.683z M33.659,26.612h4.203 l3.283,20.906H30.376L33.659,26.612z M65.962,69.388H30.038V51.519h13.445c0.011,0,0.021-0.003,0.031-0.004 c0.092-0.001,0.185-0.007,0.279-0.022c0.025-0.004,0.047-0.014,0.072-0.019c0.064-0.013,0.126-0.031,0.188-0.049 c0.079-0.023,0.155-0.05,0.229-0.082c0.055-0.024,0.107-0.05,0.16-0.078c0.076-0.042,0.148-0.089,0.218-0.14 c0.045-0.033,0.089-0.064,0.131-0.1c0.075-0.065,0.141-0.137,0.205-0.212c0.023-0.027,0.052-0.048,0.074-0.076l8.653-11.271v10.053 c0,0.856,0.546,1.618,1.356,1.894c0.812,0.278,1.707,0.005,2.229-0.676l8.653-11.271V69.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.551,55.328h-6.25c-1.104,0-2,0.896-2,2v6.25c0,1.104,0.896,2,2,2h6.25c1.104,0,2-0.896,2-2v-6.25 C52.551,56.224,51.655,55.328,50.551,55.328z M48.551,61.578h-2.25v-2.25h2.25V61.578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.054,57.328v6.25c0,1.104,0.896,2,2,2h6.25c1.104,0,2-0.896,2-2v-6.25c0-1.104-0.896-2-2-2h-6.25 C54.949,55.328,54.054,56.224,54.054,57.328z M58.054,59.328h2.25v2.25h-2.25V59.328z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.0bc493b9c0c82f0bcce2565358241b4d.svg";
export { ForwardRef as ReactComponent };